import { render } from "./MenuDamand.vue?vue&type=template&id=08cb49f8"
import script from "./MenuDamand.vue?vue&type=script&lang=js"
export * from "./MenuDamand.vue?vue&type=script&lang=js"

import "./MenuDamand.vue?vue&type=style&index=0&id=08cb49f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__